import Button, { LoadingButton } from '@atlaskit/button';
import Modal, { ModalTransition, ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import React, { useEffect, useState } from 'react';
import { messages } from 'modules/mac/messages';
import { FormattedMessage } from 'react-intl';
import { StyledModalWrapper } from './StyledComponents';
import { useDispatch, useSelector } from 'react-redux';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { styled } from 'styled-components';
import { Dimensions } from 'components/visuals';
import { cancelLicenseAutoRenew } from 'modules/mac/duck/actions/accountId';
import { licensesPreselected } from 'modules/mac/duck/actions';
import { Action, redirect } from 'redux-first-router';
import SectionMessage from '@atlaskit/section-message';
import { selectCancelledAutoRenew } from 'modules/mac/duck/selectors';

const WarningWrapper = styled.div`
  display: flex;
`;

const WarningMessageWrapper = styled.div`
  margin-left: ${Dimensions.units(2)}px;
`;

export const AnnualCancelAutoRenewModal = ({
  isOpen,
  closeModal,
  productDescription,
  accountId,
}) => {
  const dispatch = useDispatch();

  const [isError, setIsError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(0);

  const cancelledAutoRenew = useSelector(selectCancelledAutoRenew)?.[accountId];

  const cancelAutoRenew = () => {
    dispatch(cancelLicenseAutoRenew(accountId));
    setIsSubmitted(isSubmitted + 1);
  };

  useEffect(() => {
    if (isSubmitted) {
      if (!cancelledAutoRenew) {
        return;
      }
      if (cancelledAutoRenew?.success && cancelledAutoRenew.result === '') {
        dispatch(
          redirect(licensesPreselected.licensePreselectedRoute(accountId.toString(), {}) as Action),
        );
      } else if (cancelledAutoRenew?.error) {
        setIsError(true);
      }
    }
  }, [cancelledAutoRenew, isSubmitted]);

  return (
    <ModalTransition>
      {isOpen && (
        <Modal autoFocus onClose={closeModal}>
          <StyledModalWrapper>
            <ModalBody>
              <WarningWrapper>
                <WarningIcon label="Warning icon" size="large" primaryColor={colors.R400} />
                <WarningMessageWrapper>
                  <FormattedMessage
                    {...messages.cancelAutoRenewWarning}
                    values={{
                      productDescription: <strong>{productDescription}</strong>,
                      senNumber: <strong>SEN-{accountId}</strong>,
                    }}
                  />
                  {isError && (
                    <SectionMessage appearance="error">
                      <FormattedMessage {...messages.cancelAutoRenewError} />
                    </SectionMessage>
                  )}
                </WarningMessageWrapper>
              </WarningWrapper>
            </ModalBody>
          </StyledModalWrapper>
          <ModalFooter>
            <Button
              appearance="subtle"
              onClick={closeModal}
              data-cy="mac-cancel-auto-renew-modal-cancel-button"
            >
              <FormattedMessage {...messages.cancelAutoRenewCancelButton} />
            </Button>
            <LoadingButton
              appearance="primary"
              onClick={cancelAutoRenew}
              isLoading={cancelledAutoRenew?.inProgress}
              data-cy="mac-cancel-auto-renew-modal-submit-button"
            >
              <FormattedMessage {...messages.cancelAutoRenewSubmitButton} />
            </LoadingButton>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
